import axios, { AxiosRequestConfig } from 'axios';

const FORM_ID_PATTERN = /^[a-f0-9]{24}$/i;
const LANGUAGE_PATTERN = /^[A-Za-z]{3}$/;

const ALLOWED_POST_PATHS = [
    'testapp/forms/bulk/status-downstream',
    'testapp/forms/bulk/upgrade',
    'testapp/forms/bulk/status',
] as const;

type AllowedPostPath = (typeof ALLOWED_POST_PATHS)[number];

const DASHBOARD_FORM_PATH_PREFIX = 'dashboard/form/';
const DASHBOARD_STATUS_DOWNSTREAM_SUFFIX = '/status-downstream';

export function assertValidFormId(formId: string): string {
    const match = FORM_ID_PATTERN.exec(formId);
    if (!match) {
        throw new Error('Invalid form ID.');
    }

    return match[0];
}

export function assertValidLanguage(language: string): string {
    const match = LANGUAGE_PATTERN.exec(language);
    if (!match) {
        throw new Error('Invalid language.');
    }

    return match[0];
}

export function postToApiPath<T>(
    path: AllowedPostPath,
    data?: unknown,
    config?: AxiosRequestConfig
) {
    if (!ALLOWED_POST_PATHS.includes(path)) {
        throw new Error(`Disallowed API path: ${path}`);
    }

    switch (path) {
        case 'testapp/forms/bulk/status-downstream':
            return axios.post<T>(
                'testapp/forms/bulk/status-downstream',
                data,
                config
            );
        case 'testapp/forms/bulk/upgrade':
            return axios.post<T>('testapp/forms/bulk/upgrade', data, config);
        case 'testapp/forms/bulk/status':
            return axios.post<T>('testapp/forms/bulk/status', data, config);
        default: {
            const exhaustiveCheck: never = path;
            throw new Error(`Disallowed API path: ${exhaustiveCheck}`);
        }
    }
}

export function postDashboardFormStatusDownstream(
    formId: string,
    config?: AxiosRequestConfig
) {
    const validatedFormId = assertValidFormId(formId);
    const url =
        DASHBOARD_FORM_PATH_PREFIX +
        validatedFormId +
        DASHBOARD_STATUS_DOWNSTREAM_SUFFIX;

    // Client-side relative path; formId is restricted to a 24-char hex ObjectId.
    // nosemgrep
    return axios.post(url, {}, config);
}
